/* tslint:disable */
/* eslint-disable */

/**
 * eventLog driver-registration-event-log api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, GeneratedHttpClientConstraints, RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    BrandEnum,
    EventLogTrackRequest,
    VisitorTrackRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.NONE;
    Sharding: ShardingStrategy.NONE;
}

export interface TrackRequest {
    version?: string;
    brand?: BrandEnum;
}
export interface VisitorTrack2Request {
    version?: string;
    brand?: BrandEnum;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public track = async (query: TrackRequest, body: EventLogTrackRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/eventLog/track',
                service_id: 'driver-registration-event-log',
                subdomain: 'eventlog',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
        public visitorTrack = async (query: VisitorTrack2Request, body: VisitorTrackRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/visitor/track',
                service_id: 'driver-registration-event-log',
                subdomain: 'eventlog',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
